// @module DC.CartCustomization.CartExtension
define(
    'DC.CartCustomization.CartExtension.View',
    [
        'dc_cart_item_summary.tpl'
      ,	'SC.Configuration'
	  ,	'Utils'
	  ,	'Backbone'
    ],
    function (dc_cart_item_summary_tpl
            , Configuration
	        , Utils
	        , Backbone) {
      
        'use strict';

        // @class DC.CartCustomization.CartExtension.View @extends Backbone.View
        return Backbone.View.extend({
            template: dc_cart_item_summary_tpl,

            initialize: function (options) {
                this.model = options.model; // The line model
                this.container = options.container;
				this.item = this.model.toJSON().attributes.item;

                console.log(
                    'CartExtension.View initialized with model:',
                    this.model.toJSON() // Log the model's JSON data
                );
				
				this.priceSchedule = this.item.get('onlinecustomerprice_detail').priceschedule;
				console.log('PriceSchedule: ', this.priceSchedule);

                // Re-render when the model changes
                this.listenTo(this.model, 'change', this.render);
            }
			,
			checkFreightApplicability: function (quantity) {
				console.log('Freight Applicable function started with quantity: ' + quantity);
                console.log('Item: ', this.item);
                console.log('Item Freight Value: ', this.item.get('custitem_bags_freight1'));

				if (!this.priceSchedule || !this.priceSchedule.length) {
					console.log('Price schedule is empty or not defined.');
					return false;
				}
			
				// Find exact match for minimumquantity
				var exactMatchIndex = -1;
				for (var i = 0; i < this.priceSchedule.length; i++) {
					if (quantity === this.priceSchedule[i].minimumquantity) {
						exactMatchIndex = i;
						break;
					}
				}

				if (exactMatchIndex !== -1) {
					// If exact match found, check freight for this index
					var freightField = 'custitem_bags_freight' + (exactMatchIndex + 1);
					var freightValue = this.item.get(freightField);
			
					console.log(
						'Exact match for quantity: ' + quantity + 
						', Freight Field: ' + freightField + 
						', Freight Value: ' + freightValue
					);
			
					return !!freightValue; // Return true if freight is applicable
				}

				console.log('Exact match does not found with quantity: ' + quantity);

				// Find the nearest lesser and greater quantities
				var lesserIndex = -1;
				var greaterIndex = -1;

				for (var j = 0; j < this.priceSchedule.length; j++) {
					var schedule = this.priceSchedule[j];
					if (quantity > schedule.minimumquantity) {
						lesserIndex = j; // Keep track of the last lesser index
					} else if (quantity < schedule.minimumquantity && greaterIndex === -1) {
						greaterIndex = j; // First greater index found
					}
				}
				console.log('Lesser Index: ' + lesserIndex + ', Greater Index: ' + greaterIndex);

				var lesserFreight = false;
				var greaterFreight = false;
				
				if (lesserIndex !== -1) {
					lesserFreight = this.item.get('custitem_bags_freight' + (lesserIndex + 1));
				}
				
				if (greaterIndex !== -1) {
					greaterFreight = this.item.get('custitem_bags_freight' + (greaterIndex + 1));
				}
									
				console.log(
					'Lesser Freight: ' + lesserFreight + ', Greater Freight: ' + greaterFreight
				);

				return !!lesserFreight || !!greaterFreight; // Return true if any freight is applicable
			}
			,
            // @method getContext @return DC.CartCustomization.CartExtension.View.Context
            getContext: function () {
				// get all required attributes
                var itemId = this.model.attributes.get('internalid') || 'Unknown Item ID';
				var totalQuantity = this.model.attributes.get('quantity');
				var amount_formatted = this.model.attributes.get('amount_formatted');
				var sku = this.model.toJSON().attributes.item.get('_sku');

				var freightApplicable = this.checkFreightApplicability(totalQuantity);
                if (freightApplicable) {
                    amount_formatted = amount_formatted +' (+FRT)';
                }
              
                console.log('Rendering context with:', {
                    itemId: itemId,
					totalQuantity: totalQuantity,
					amount_formatted: amount_formatted,
					sku: sku,
					freightApplicable: freightApplicable
                });

                // Return context for the template
                return {
                    hasFreight: freightApplicable ? 'Yes' : 'No',
                    itemId: itemId,
					totalQuantity: totalQuantity,
					amount_formatted: amount_formatted,
					sku: sku
                };
            }
        });
    }
);
